export const FAILURE_MODES = [
  {
    id: 'scrap',
    label: 'Scrap',
    short: 'Scrap',
    description: 'Unit cannot be recovered — full BOM + labor loss.',
    bg: '#FCEBEB',
    fg: '#791F1F',
  },
  {
    id: 'field',
    label: 'Field failure / warranty',
    short: 'Field',
    description: 'Escapes the plant and fails at the customer.',
    bg: '#FAEEDA',
    fg: '#633806',
  },
  {
    id: 'rework-down',
    label: 'Rework downstream',
    short: 'Rework (down)',
    description: 'Caught at EOL test/QC — requires teardown.',
    bg: '#FAECE7',
    fg: '#712B13',
  },
  {
    id: 'rework-station',
    label: 'Rework at station',
    short: 'Rework (station)',
    description: 'Caught and fixed in-line — minor time loss.',
    bg: '#FBEAF0',
    fg: '#72243E',
  },
  {
    id: 'cosmetic',
    label: 'Cosmetic / minor',
    short: 'Cosmetic',
    description: 'Functional but flagged — quick touch-up.',
    bg: '#EEEDFE',
    fg: '#3C3489',
  },
  {
    id: 'none',
    label: 'No impact',
    short: 'None',
    description: 'Informational step only.',
    bg: '#F1EFE8',
    fg: '#444441',
  },
];

export const FAILURE_MODE_MAP = Object.fromEntries(
  FAILURE_MODES.map((m) => [m.id, m])
);

export const DEFAULT_STEP_MODE = 'rework-station';

export const DEFAULT_ECONOMICS = {
  bomCost: 180,
  laborRate: 42,
  reworkMinutes: 8,
  warrantyCost: 400,
  detectProbability: 60,
  operatingDaysPerYear: 250,
};

export const ECONOMICS_FIELDS = [
  {
    key: 'bomCost',
    label: 'BOM cost per unit',
    unit: '$',
    min: 0,
    max: 1000,
    step: 10,
    help: 'Material cost of a unit — used when a defect forces scrap.',
  },
  {
    key: 'laborRate',
    label: 'Loaded labor rate',
    unit: '$/hr',
    min: 0,
    max: 150,
    step: 1,
    help: 'Fully-burdened operator cost per hour (wages + overhead).',
  },
  {
    key: 'reworkMinutes',
    label: 'Average rework time',
    unit: 'min',
    min: 0,
    max: 60,
    step: 1,
    help: 'Time to undo + redo a typical defect at the station.',
  },
  {
    key: 'warrantyCost',
    label: 'Warranty cost per field failure',
    unit: '$',
    min: 0,
    max: 2000,
    step: 25,
    help: 'Average cost of a single customer-facing failure (claims, returns, goodwill).',
  },
  {
    key: 'detectProbability',
    label: 'EOL detection probability',
    unit: '%',
    min: 0,
    max: 100,
    step: 5,
    help: 'Fraction of defects end-of-line testing catches anyway, even without the system.',
  },
  {
    key: 'operatingDaysPerYear',
    label: 'Operating days per year',
    unit: 'days',
    min: 100,
    max: 365,
    step: 5,
    help: 'How many days the line runs per year. 250 = typical 5-day × 50-week. 365 = continuous 24/7.',
  },
];

export const OVERRIDE_KEYS = ['bomCost', 'reworkMinutes', 'warrantyCost'];
